class exports.KoModel extends DependencyInjection

    constructor: () ->
        super()

        # TODO: pretty sure this should be ?=, not =, so that @handler can be
        # set correctly in a child's constructor
        @handler = null

        @ignore 'handler'

        @transform (v) ->
            # if the value is a KO observable or computed property, get the
            # current value to return when serializing the object
            if ko.isObservable(v) or ko.isComputed(v)
                v = v()

            return v

        @registerCustomBindings()


    serialize: () ->
        return ko.toJSON @_cleanUp()


    toJS: () ->
        return ko.toJS @_cleanUp()


    # stub
    # This is where you should register any custom ko.bindingHandlers
    registerCustomBindings: () ->
        undefined
